import { z } from 'zod'
import { GetDocumentTypeEnum } from './document'
import { GetOrganisationSchema } from './organisation'
import { GetUserSchema } from './user'

export const GetCustomsSchema = z.object({
  notes: z.string().nullish(),
  organisation: GetOrganisationSchema.pick({ id: true, name: true }).nullish(),
  required: z.boolean(),
  responsible_party: z.enum(['organisation', 'customer']).nullish(),
})

export const GetCustomsDocumentMediaSchema = z.object({
  name: z.string(),
  size: z.number(),
})

export const GetCustomsDocumentSchema = z.object({
  created_at: z.coerce.date(),
  id: z.number(),
  load_id: z.number().nullish(),
  media: GetCustomsDocumentMediaSchema,
  type: GetDocumentTypeEnum,
  user: GetUserSchema,
})

export type GetCustomsDocument = z.infer<typeof GetCustomsDocumentSchema>
